import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Table from 'react-bootstrap/Table';
import Skeleton from 'react-loading-skeleton'
//import { Document, Page, pdfjs } from 'react-pdf'
//import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import axios from 'axios';
import ConfirmPopup from './../modal/modal';
import FormFileUpload from "./../inputs/fileupload";
import FormSelect from './../inputs/select';
import ManagementTable from "./../tables/managementTable";
import { formatMonthYear, formatDateTime, prepareForm } from "./../../utils";
import '@progress/kendo-theme-default/dist/all.css';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import { SampleFileBase64 } from "./samplepdf";
import * as PDFJS from 'pdfjs-dist';
import worker from 'pdfjs-dist/webpack';
import FormSwitch from './../inputs/switch';
import FormText from './../inputs/text';
import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';

import frMessages from "./../tables/fr-FR.json";
loadMessages(frMessages, "fr");

const DocumentsAdmin = (props) => {

    useEffect(() => {
        PDFJS.GlobalWorkerOptions.workerSrc = worker
    });    

    const pdfs = ["https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK", "https://owasp.org/www-pdf-archive/GOD17-CORS.pdf", "https://www.entnet.org/wp-content/uploads/2021/04/Instructions-for-Adding-Your-Logo-2.pdf"]
    const [page, setPage] = useState(1);
    const [file, setFile] = useState("");
    const skeletonCount = 5;
    const [numPages, setNumPages] = useState(0);
    
    let navigate = useNavigate();
    const { usersAdminStore, loginStore, invoiceStore, activitiesStore, fileStore, utilsStore, winbizStore } = useStores();
    const { getDummy, users, user, dummies } = usersAdminStore;
    const { search, activities } = activitiesStore;
    const { getTemplates, templates } = utilsStore;
    const { getInvoiceFile } = fileStore;
    const { syncInvoiceWinbiz } = winbizStore;

    const { upload, getAll } = fileStore;
    const { sendViaEmail, cancel, createCreditNote, changeDate } = invoiceStore;
    const { t, i18n } = useTranslation();
    const { accountInfo } = loginStore;
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSendingMail, setSendingMail] = useState(false);
    const [validated, setValidated] = useState(false);
    const [modalSettings, setModalSettings] = useState({});
    const [showValidateConfirm, setShowValidateConfirm] = useState(false);
    const [pdfData, setPdfData] = useState(null);

    const [showMailConf, setShowMailConf] = useState(false);
    const [mailConfValidated, setMailConfValidated] = useState(false);
    const [invoice, setInvoice] = useState(null);
    const [winbizSyncing, setWinbizSyncing] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    useEffect(() => {
        setIsLoading(props.isLoading);
    }, [props.isLoading]);


    const handleMailConfirmation = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = prepareForm(event, false, ["id"]);

            setSendingMail(true);
            sendViaEmail(formData).then(() => {
                setSendingMail(false);
                setMailConfValidated(false);
                setShowMailConf(false);

                props?.afterSend?.();

            })

        }
        setMailConfValidated(true);
    }

    const openRandomPdf = () => {
        var min = 0;
        var max = pdfs.length - 1;
        let rand = Math.floor(Math.random() * (max - min + 1)) + min;
        setFile("https://localhost:7231/api/invoices/report");
        setPage(1)
    }

    const openPdf = (invoice, isReport) => {
        if (invoice == null)
            return;

        //console.log(invoice);
        //var overrideFilename = `${invoice.consultant?.username?.toUpperCase()} ${invoice?.year} ${String(invoice?.month).padStart(2,'0')} ${invoice?.project?.client?.name}.pdf`;
        getInvoiceFile(invoice.id, isReport).then((data) => {            
            var fileReader = new FileReader();
            fileReader.onload = function (event) {                
                setPdfData({
                    id: invoice.id,
                    filename: data?.utf_filename ?? data.filename,
                    data: event.target.result,
                    isReport: isReport,
                    obsolete:invoice?.obsolete
                });
            };
            fileReader.readAsArrayBuffer(data.bytes);
        });
    }

    const onPageChange = (props) => {
        setIsLoading(true);
        getAll(props.page + 1, props.filter, props.sort).then(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        setIsLoading(true);
        Promise.all([getDummy(), search(), getTemplates()]).then(() => setIsLoading(false));
    }, [getDummy]);


    const handleUpload = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = Object.fromEntries(new FormData(event.target).entries());
            
            var data = new FormData();
            data.append("file", formData.file);
            data.append("activityId", formData.activityId);
            //handleClose();*/
            upload(data).then(() => handleClose())
        }
        setValidated(true);
    };

    const cancelInvoice = (invoice, isCreditNote) => {
        //alert(invoice?.id)
        cancel(invoice?.id, isCreditNote ?? false).then(() => {
            props?.afterSend?.();
            setPdfData(null);
        })
    }

    const createCredit = (invoice) => {
        //alert(invoice?.id)
        createCreditNote(invoice?.id).then(() => {
            props?.afterSend?.();
            setPdfData(null);
        })
    }

    const getInvoiceMails = (invoice) => {
        var list = [];
        if (invoice?.project?.billingEmail) {
            var mails = invoice?.project?.billingEmail.split(/,|;/);
            mails?.forEach((m) => list.push(m));
        }

        if (invoice?.project?.billingEmailCopy) {
            var mails = invoice?.project?.billingEmailCopy.split(/,|;/);
            mails?.forEach((m) => list.push(m));
        }
        return list?.length > 0 ? list : [];
    }

    const getInvoiceMailsTo = (invoice) => {
        var list = [];
        if (invoice?.project?.billingEmail) {
            var mails = invoice?.project?.billingEmail.split(/,|;/);
            mails?.forEach((m) => list.push(m));
        }

        return list?.length > 0 ? list : [];
    }

    const getInvoiceMailsCC = (invoice) => {
        var list = [];
      
        if (invoice?.project?.billingEmailCopy) {
            var mails = invoice?.project?.billingEmailCopy.split(/,|;/);
            mails?.forEach((m) => list.push(m));
        }
        return list?.length > 0 ? list : [];
    }

    const getInvoiceMailsBCC = (invoice) => {
        var list = [];

        if (invoice?.project?.billingEmailsBbc) {
            var mails = invoice?.project?.billingEmailsBbc.split(/,|;/);
            mails?.forEach((m) => list.push(m));
        }
        return list?.length > 0 ? list : [];
    }
    
    const [fields, setFields] = useState({});

    const handleChangeInvoiceDate = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            setModalLoading(true);
            const formData = Object.fromEntries(new FormData(event.target).entries());                      
            var parts = formData.date?.split("-");
            changeDate(formData.id, parts[0],parts[1],parts[2]).then(() => {
                setShowInvoiceDate(false);                
            }).finally(() => {
                setModalLoading(false)
                props?.afterSend?.();
            });
        }

        setInvoiceDateValidated(true);
    }
    const [showInvoiceDate, setShowInvoiceDate] = useState(false);
    const [invoiceDateValidated, setInvoiceDateValidated] = useState(false);
    return (
        <Card>
            <Card.Body>

                <Modal show={showInvoiceDate} onHide={() => setShowInvoiceDate(false)}>
                    <Form noValidate validated={invoiceDateValidated} onSubmit={handleChangeInvoiceDate}>
                        <Modal.Header closeButton>
                            <Modal.Title>{t("changeInvoiceDate")} ({invoice?.number})</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Stack gap={2}>                                  
                                {t("changeInvoiceDateConfirmation")}
                                <FormText hidden isNumber id="id" type="number" object={invoice} />
                                <input type="date" required name="date" defaultValue={invoice?.customDate ? new Date(invoice.customDate).toISOString()?.substring(0, 10):  new Date()?.toISOString()?.substring(0, 10)} /*onChange={(v) => {console.log(v) }}*/ />
                            </Stack>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" type="submit" disabled={modalLoading} /*onClick={() => { alert("dsa") }}*/>
                                {modalLoading && < Spinner animation="border" role="status" size="sm"></Spinner>}
                                &nbsp;&nbsp;
                                {t("changeInvoiceDate")}                                                                
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/*MailConfirmationModal*/}
                <Modal show={showMailConf} onHide={() => { setShowMailConf(false); setMailConfValidated(false) }}>
                    <Form noValidate validated={mailConfValidated} onSubmit={handleMailConfirmation}>
                        <Modal.Header closeButton>
                            <Modal.Title>{t("invoiceConfirmation")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            {getInvoiceMails(invoice)?.length ?
                                <Stack gap={2}>
                                    <span>{t("invoiceMailConfirmation")}:</span>
                                    <span>{t("sendTo")}:</span>
                                    {getInvoiceMailsTo(invoice).map((x, idx) => {
                                        if (x) {
                                            return (<div key={idx}><i>{x}</i><br /></div>);
                                        }
                                    })}
                                    <br />
                                    <span>{t("sendCc")}</span>
                                    {getInvoiceMailsCC(invoice).map((x, idx) => {
                                        if (x) {
                                            return (<div key={idx}><i>{x}</i><br /></div>);
                                        }
                                    })}
                                    <br />
                                    <span>{t("sendBcc")}:</span>
                                    {getInvoiceMailsBCC(invoice).map((x, idx) => {
                                        if (x) {
                                            return (<div key={idx}><i>{x}</i><br /></div>);
                                        }
                                    })}
                                    <br />
                                    <FormText hidden isNumber id="id" type="number" object={invoice} />
                                    <FormSelect required hideNone label={t("template")} id="templateId" isLoading={isLoading} items={templates?.filter((t) => t.event === 4)?.map((x) => ({ id: x.id, name: x.name }))} itemId="id" itemLabel="name" object={fields} />
                                    <br />

                                    <FormSwitch type="checkbox" title={t("projectReportConfig")} label={t("sendReport")} id="report" isLoading={isLoading} object={fields} />

                                    <FormSwitch type="checkbox" title={t("projectMergeDocumentsConfig")} label={t("mergeDocuments")} id="mergeDocuments" isLoading={isLoading} object={fields} />
                                    {/*<span>{t((invoice?.project?.sendReport ? "willSendReport" : "wontSendReport"))}</span>*/}
                                </Stack>
                                :
                                <Stack gap={2}>
                                    <span>{t("NoMailsToSend")}</span>
                                    <a href={`/administration/projects/${invoice?.project?.id}`} target="_blank">{t("pleaseAddEmail")}</a>
                                </Stack>
                            }

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" type="submit" disabled={isSendingMail || getInvoiceMails(invoice)?.length == 0 ? true : false} /*onClick={() => { alert("dsa") }}*/>
                                {t(isSendingMail ? "sending" : "send")}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>


                {/*IGNORAR - NO SE USA*/}
                <Modal show={show} onHide={handleClose}> 
                    <Form noValidate validated={validated} onSubmit={handleUpload}>
                        <Modal.Header closeButton>
                            <Modal.Title>{t("uploadDocument")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Stack gap={2}>
                                <FormFileUpload required label={t("files")} id="file" isLoading={isLoading} innerText={t("dragDropDocuments")} accept=".pdf" />
                                <FormSelect required label={`${t("relatedActivity")}:`} id="activityId" isLoading={isLoading} itemId="id" itemLabel="name" items={activities} />
                            </Stack>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                                {t("uploadDocument")}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <ConfirmPopup show={showValidateConfirm} isDeleting={false} onClose={() => setShowValidateConfirm(false)} title={modalSettings?.title} body={modalSettings?.body} onClick={modalSettings.onConfirm} />

                <div>
                    {!props.billing && <Row>
                        <Col xs={1} className="float-center">
                            {isLoading ? <Skeleton /> : <b>{t('documents')}</b>}
                        </Col>

                        <Col md="auto" className="align-items-center">

                            {isLoading ? <Skeleton width={100} /> : <b>{t('consultant')}:</b>}


                        </Col>
                        <Col md="auto">
                            {isLoading ? <Skeleton width={150} height={30} /> : <Form.Select aria-label="John">
                                <option>Please select..</option>
                                <option value="1">Johasdasn</option>
                                <option value="2">Paul</option>
                                <option value="3">Roy</option>
                            </Form.Select>}

                        </Col>

                        <Col className="text-end">
                            {isLoading ? <Skeleton width={150} height={35} /> : <button className="btn btn-secondary" onClick={() => {

                                setShow(true);
                            }}>{t('uploadDocument')}</button>
                            }

                        </Col>
                    </Row>}


                    <Row className="my-2">
                        <Col>
                            <Table className="table-sm timesheet" hover>
                                <thead>

                                    {props.billing ?
                                        <tr key={1}>
                                            <th>{isLoading ? <Skeleton /> : t('file')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('type')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('billingPeriod')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('created')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('sent')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('report')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('actions')}</th>
                                            <th>{isLoading ? <Skeleton /> : "Winbiz"}</th>

                                        </tr>
                                        :
                                        <tr key={1}>
                                            <th>{isLoading ? <Skeleton /> : t('file')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('modified')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('author')}</th>
                                            <th>{isLoading ? <Skeleton /> : t('type')}</th>
                                        </tr>
                                    }

                                </thead>
                                <tbody>
                                    {(isLoading || (props.billing && !props?.items)) &&
                                        Array.from({
                                            length: skeletonCount
                                        }).map((_, index) => (
                                            <tr key={index}>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>

                                            </tr>)
                                        )}

                                    {(!isLoading && !props?.items?.length) &&
                                        <tr key="-1"><td colSpan="100%">{t("noInvoicesFound")}</td></tr>
                                    }
                                    {!isLoading && props?.items?.map((invoice, index) => {

                                        return (props.billing ?

                                            <tr key={index} onClick={(e) => { openPdf(invoice, false) }} style={{ cursor: "pointer", fontWeight: invoice.id == pdfData?.id ? "bold" : "" }}>
                                                <td><Stack direction="horizontal" gap={2}><FontAwesomeIcon icon={solid("file-pdf")} color="#AC0F29" size="2x" />{invoice.number} {invoice?.sentWinbiz ? (<FontAwesomeIcon title={`${t("winbizSynchronized")} (${formatDateTime(invoice.sentWinbiz)})`} icon={(solid("circle-check"))} color="green" size="1x" />) : ""}</Stack></td>
                                                <td>{invoice.type === 1 ? t("creditNote") : t("invoice")} {(invoice.creditNote || (invoice.type === 0 && invoice.deleted) ? ` (${t("cancelled")})` : "")}</td>
                                                <td>{formatMonthYear(new Date(invoice.year, invoice.month - 1, 1))}</td>
                                                <td>{formatDateTime(new Date(invoice.created))}</td>
                                                <td>{invoice.sentByEmail ? formatDateTime(new Date(invoice.sentByEmail)) :
                                                    invoice.type === 0 ?
                                                        (<Button variant="secondary" color="#DCDCDC" onClick={(e) => {
                                                            e.stopPropagation();

                                                            if (isSendingMail) return;
                                                            setInvoice(invoice);
                                                            setFields({ report: invoice?.project?.sendReport ?? false, templateId: invoice?.project?.lastTemplateId ?? null, mergeDocuments: invoice?.project?.mergeDocuments ?? false, });
                                                            setShowMailConf(true);
                                                        }
                                                        }><FontAwesomeIcon icon={solid("envelope")} /></Button>
                                                        
                                                        ) :
                                                        "-"
                                                }
                                                </td>
                                                <td>{
                                                    invoice.reportFilename && <Button variant="secondary" color="#DCDCDC" onClick={(e) => {
                                                        e.stopPropagation();
                                                        openPdf(invoice, true);
                                                    }
                                                    }><FontAwesomeIcon icon={solid("eye")} /></Button>
                                                }

                                                </td>
                                                <td>
                                                    <Stack direction="horizontal" gap={1}>
                                                        {(invoice.type === 0 && !invoice.creditNote && !invoice.deleted) && <span title={t("cancelInvoice")}><Button variant="secondary" color="#DCDCDC" onClick={(e) => {
                                                            e.stopPropagation();
                                                            setModalSettings({
                                                                isDeleting: true,
                                                                title: t("cancelInvoice"),
                                                                body: t("cancelInvoiceConfirmation"),
                                                                onConfirm: () => cancelInvoice(invoice)
                                                            });
                                                            setShowValidateConfirm(true);
                                                        }}><FontAwesomeIcon icon={solid("xmark")} /></Button></span>}

                                                        {(invoice.type === 0 && !invoice.creditNote && !invoice.deleted) && <span title={t("createCreditNote")}><Button variant="secondary" color="#DCDCDC" onClick={(e) => {
                                                            e.stopPropagation();
                                                            setModalSettings({
                                                                isDeleting: true,
                                                                title: t("createCreditNote"),
                                                                body: t("creditNoteConfirmation"),
                                                                onConfirm: () => createCredit(invoice)
                                                            });
                                                            setShowValidateConfirm(true);

                                                        }}><FontAwesomeIcon icon={solid("dollar-sign")} /></Button></span>}

                                                        {<span title={t("changeInvoiceDate")}><Button variant="secondary" color="#DCDCDC" onClick={(e) => {
                                                            e.stopPropagation();                                                            
                                                            setPdfData(null);
                                                            setInvoice(invoice);
                                                            setShowInvoiceDate(true);

                                                        }}><FontAwesomeIcon icon={solid("pen")} /></Button></span>}

                                                    </Stack>
                                                </td>

                                                <td style={{ textAlign:"center" }}>{
                                                    winbizSyncing?.isLoading && winbizSyncing?.type === "invoice" && winbizSyncing?.id === invoice?.id ?
                                                        <Spinner  animation="border" role="status" size="sm"></Spinner>
                                                        :<Button variant="secondary" color="#DCDCDC" disabled={winbizSyncing?.isLoading} onClick={(e) => {
                                                            e.stopPropagation();
                                                            //syncInvoiceWinbiz()
                                                            setModalSettings({
                                                                title: t("syncWinbizInvoices"), body: t("confirmWinbizInvoices"), onConfirm: () => {
                                                                    setWinbizSyncing({ type: "invoice", id: invoice?.id, isLoading: true });                                                                    
                                                                    syncInvoiceWinbiz(invoice.id, () => {
                                                                        invoice.sentWinbiz = new Date();
                                                                    }, () => {}).finally(() => {
                                                                        setWinbizSyncing({ isLoading: false })
                                                                        setShowValidateConfirm(false);
                                                                    });
                                                                }
                                                            });
                                                            setShowValidateConfirm(true)
                                                        }
                                                        }><FontAwesomeIcon icon={solid("sync")} />
                                                        </Button>                                                
                                                }
                                                </td>

                                            </tr>
                                            :
                                            <tr key={index} onClick={() => { openRandomPdf() }} style={{ cursor: "pointer" }}>
                                                <td><Stack direction="horizontal" gap={2}><FontAwesomeIcon icon={solid("file-pdf")} color="#AC0F29" size="2x" />{invoice.username}</Stack></td>
                                                <td>{invoice.name}</td>
                                                <td>{invoice.surname}</td>
                                                <td>{invoice.email}</td>
                                            </tr>)

                                    })}

                                </tbody>
                            </Table>
                        </Col>

                        <Col className="p-0">
                            {(pdfData && pdfData.obsolete) && <div style={{ display: "flex", backgroundColor: "red", color: "white", justifyContent: "center" }}>
                                {t("documentObsolete")}
                            </div>}
                            {pdfData && <LocalizationProvider language={i18n.language}><PDFViewer style={{ height: pdfData ? "58vh" : null }}
                                saveFileName={pdfData?.filename}
                                arrayBuffer={pdfData?.data} tools={[
                                    "pager",
                                    "spacer",
                                    "zoomInOut",
                                    "zoom",
                                    "selection",
                                    "spacer",
                                    "search",/*,
                            "open",*/
                                    "download"/*,
                            "print",*/]}
                            /></LocalizationProvider>}
                            {!pdfData && <Stack orientation="vertical" style={{ backgroundColor: "#f1f1f1", height: "100%" }}>
                                <span className="text-center my-auto">{t("noInvoiceSelected")}</span>
                            </Stack>}
                        </Col>


                        {file && <Col className="p-0" >

                            {isLoading ? <Skeleton height={250} /> : <div style={{ backgroundColor: "#3F3E43" }} className="text-center" >

                                {Boolean(numPages > 0) && (
                                    <Stack direction="horizontal" style={{ backgroundColor: "#848484", color: "#DCDCDC" }}>
                                        <Button variant="outline secondary" color="#DCDCDC" disabled={page === 1} onClick={() => setPage(page - 1)}>
                                            <FontAwesomeIcon icon={solid("caret-left")} />
                                        </Button>
                                        <span className="w-100 text-center"><b>{page}/{numPages}</b></span>
                                        <Button variant="outline secondary" onClick={() => setPage(page + 1)} disabled={page === numPages}>
                                            <FontAwesomeIcon className="ms-auto" icon={solid("caret-right")} />
                                        </Button>
                                    </Stack>
                                )}
                            </div>}
                        </Col>}
                    </Row>



                </div>
            </Card.Body>
        </Card>

    );
};

export default observer(DocumentsAdmin);
